function v(t, n, e, i) {
  if (t) {
    var a = {
      syntheticEvent: n,
      nativeEvent: n.nativeEvent,
      target: e
    };
    t.call(void 0, Object.assign(a, i));
  }
}
export {
  v as d
};
